import React, { useEffect } from 'react';

import { track } from '@betterment/js-runtime';
import { Box, Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { CenteredWorkflowLayout, Heading } from '@betterment/style-closet-react';

import { trackClick } from '../../features/track';
import Footer from '../../Shared/components/Footer';
import { MFA_LOCKED_SUPPORT_PHONE } from '../../Shared/constants';
import { urlBuilder } from '../../Shared/urlBuilder';

interface Props {
  title: string;
}

const AccountGroupLockedError: React.FC<React.PropsWithChildren<Props>> = ({ title }) => {
  useEffect(() => {
    track('ElementViewed', { name: 'AccountGroupLockSuspension', flow: 'OpenJointCheckingSecondary' });
  }, []);
  return (
    <CenteredWorkflowLayout title={title}>
      <CenteredWorkflowLayout.Slot name="content">
        <>
          <Box
            css={{
              marginBottom: 'space.300',
            }}
          >
            <Icon name="ExclamationCircle" size="large" color="icon" />
          </Box>
          <Heading as="h1" fontSize={[5, 6]} mb="8">
            One of your existing accounts with us isn't in good standing
          </Heading>
          <Box
            css={{
              marginBottom: 'space.400',
            }}
          >
            <Text as="p">You'll need to resolve the matter before you can open your Joint Checking account.</Text>
            <Text as="p">
              Please call us at <a href={`tel:${MFA_LOCKED_SUPPORT_PHONE}`}>{MFA_LOCKED_SUPPORT_PHONE}</a> so we can
              assist you.
            </Text>
          </Box>
        </>
        <CenteredWorkflowLayout.Actions>
          <SambaAutoLink
            onClick={() => trackClick({ name: 'GotIt', flow: 'OpenJointCheckingSecondary' })}
            to={urlBuilder.appHome.absolute()}
            variant="solidPrimary"
          >
            Got it
          </SambaAutoLink>
        </CenteredWorkflowLayout.Actions>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};
export default AccountGroupLockedError;
